<template>
  <div id="donut-chart">

    <div id="chart" v-if="dataReady">
      <apexchart 
        type=donut 
        width=380 
        :options="chartOptions" 
        :series="series" />
    </div>

    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'donut-chart',
    props: ['costs', 'finalTotal'],
    data: () => ({
        dataReady: false,
        series: null,
        chartOptions: {
          title: {
            text: 'Total Cost of Poor Quality'
          },
          subtitle: {
            text: null,
            style: {
              fontSize: '28px',
              color: 'green'
            }
          },
          labels: ['Prevention', 'Appraisal', 'Internal Failure', 'External Failure', 'Other'],
          dataLabels: {
            enabled: false
          },
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                show: false
              }
            }
          }],
          legend: {
              position: 'right',
              offsetY: 0,
              height: 230,
          }
        }
    }),
    components: {
        apexchart: VueApexCharts,
    },
    created: function() {
      let yourCosts = [];
      for (let key in this.costs) {
        const value = (this.costs[key] / this.finalTotal) * 100;
        yourCosts.push(value);
      }
      this.series = yourCosts;
      this.chartOptions.subtitle.text = `$${this.finalTotal}`;
      this.dataReady = true;
    }
}
</script>
<style scoped>
</style>